module.exports = __webpack_public_path__ + "1cec38d4fddbe44e9962912d8c927fad.png";